import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UpgradePlanComponent} from './upgrade-plan/upgrade-plan.component';
import {PromoCountdownComponent} from './promo-countdown/promo-countdown.component';

@NgModule({
    declarations: [
        UpgradePlanComponent,
        PromoCountdownComponent,
    ],
    imports: [
        CommonModule
    ],
    exports: [
        UpgradePlanComponent,
        PromoCountdownComponent
    ]
})
export class MessagesModule {
}
